import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { Switch } from "@mui/material";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";
import { useDispatch, useSelector } from "react-redux";
import { setMixerApp, setObsStatus, setRecordMode, setSourceMode, setStreamMode, setVCam, setVMixApp } from "../../Slice/vMixButtons";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  overflowY: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
};

const SettingModal = ({ open, handleModalToggle }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [manualMode, setManualMode] = useState(false);

  const sourceMode = useSelector((state) => state.vMixButton.sourceMode);

  const recordMode = useSelector((state) => state.vMixButton.recordMode);

  const streamMode = useSelector((state) => state.vMixButton.streamMode);

  const vMixApi = useSelector((state) => state.vMixButton.vMixApi);

  const mixerApi = useSelector((state) => state.vMixButton.mixerApi);

  const vCam = useSelector((state) => state.vMixButton.vCam);

  const obs = useSelector((state) => state.vMixButton.obs);

  const [vmixSettings, setVmixSettings] = useState({
    webControllerUrl: "http://127.0.0.1:8088",
    mixerApiUrl: "",
    overlayChannelId: 2,
    inputId: "ICG",
    twoLineInputId: "DUAL_LINE",
    input: "",
    manualMode: false,
    selectedName1: "line1.Text",
    selectedName2: "line2.Text",
    sourceMode: false,
    recordMode: false,
    streamMode: false,
  });

  const handleVmixSettingsChange = (event) => {
    event.preventDefault();

    let settings = { ...vmixSettings };
    const value = event.target.value;
    if ((value !== "-1" && value <= 4 && value >= 1) || value === "") {
      settings = {
        ...settings,
        [event.target.name]: value,
      };
      setVmixSettings(settings);
      localStorage.setItem("vmixSettings", JSON.stringify(settings));
    }
  };

  const handleVmixInputIDSettingsChange = (event) => {
    event.preventDefault();

    let settings = { ...vmixSettings };
    const value = event.target.value;
    settings = {
      ...settings,
      [event.target.name]: value,
    };
    setVmixSettings(settings);
    localStorage.setItem("vmixSettings", JSON.stringify(settings));
  };

  const handleVmixSettingsApiChange = (event) => {
    event.preventDefault();

    let settings = { ...vmixSettings };
    const value = event.target.value;
    settings = {
      ...settings,
      [event.target.name]: value,
    };
    setVmixSettings(settings);
    localStorage.setItem("vmixSettings", JSON.stringify(settings));
  };

  const handleMixerSettingsApiChange = (event) => {
    event.preventDefault();

    let settings = { ...vmixSettings };
    const value = event.target.value;
    settings = {
      ...settings,
      [event.target.name]: value,
    };
    setVmixSettings(settings);
    localStorage.setItem("vmixSettings", JSON.stringify(settings));
  };

  const handleVmixSettingsInputTextIDChange = (event) => {
    event.preventDefault();

    let settings = { ...vmixSettings };
    const value = event.target.value;
    if (value !== "-1") {
      settings = {
        ...settings,
        [event.target.name]: value,
      };
      setVmixSettings(settings);
      localStorage.setItem("vmixSettings", JSON.stringify(settings));
    }
  };

  const handleVmixSettingsManualMode = (event) => {
    const value = event.target.checked;
    setManualMode(value);
    localStorage.setItem("manualMode", value);
    localStorage.setItem("vmixSettings", JSON.stringify(vmixSettings));
  };

  const handleVmixSettingsSourceMode = (event) => {
    const value = event.target.checked;
    dispatch(setSourceMode(value));
    localStorage.setItem("sourceMode", value);
    localStorage.setItem("vmixSettings", JSON.stringify(vmixSettings));
  };

  const handleVmixSettingsRecordMode = (event) => {
    const value = event.target.checked;
    dispatch(setRecordMode(value));
    localStorage.setItem("recordMode", value);
    localStorage.setItem("vmixSettings", JSON.stringify(vmixSettings));
  };

  const handleVmixSettingsStreamMode = (event) => {
    const value = event.target.checked;
    dispatch(setStreamMode(value));
    localStorage.setItem("streamMode", value);
    localStorage.setItem("vmixSettings", JSON.stringify(vmixSettings));
  };

  const handleVmixSettingsVMixApiMode = (event) => {
    const value = event.target.checked;
    dispatch(setVMixApp(value));
    localStorage.setItem("vMixApi", value);
    localStorage.setItem("vmixSettings", JSON.stringify(vmixSettings));
  };

  const handleVmixSettingsMixerApiMode = (event) => {
    const value = event.target.checked;
    dispatch(setMixerApp(value));
    localStorage.setItem("mixerApi", value);
    localStorage.setItem("vmixSettings", JSON.stringify(vmixSettings));
  };

  const handleVmixSettingsObsMode = (event) => {
    const value = event.target.checked;
    if (value) {
      dispatch(setSourceMode(value));
      localStorage.setItem("sourceMode", value);
      dispatch(setRecordMode(value));
      localStorage.setItem("recordMode", value);
      dispatch(setStreamMode(value));
      localStorage.setItem("streamMode", value);
      dispatch(setVCam(value));
      localStorage.setItem("vCam", value);
    }
    dispatch(setObsStatus(value));
    localStorage.setItem("obs", value);
    localStorage.setItem("vmixSettings", JSON.stringify(vmixSettings));
  };

  const handleVmixSettingsVCamMode = (event) => {
    const value = event.target.checked;
    dispatch(setVCam(value));
    localStorage.setItem("vCam", value);
    localStorage.setItem("vmixSettings", JSON.stringify(vmixSettings));
  };

  useEffect(() => {
    let manualMode = JSON.parse(localStorage.getItem("manualMode"));
    if (manualMode) {
      setManualMode(manualMode);
    }
  }, [manualMode]);

  useEffect(() => {
    let settings = localStorage.getItem("vmixSettings");
    if (settings) {
      settings = JSON.parse(settings);
      setVmixSettings(settings);
    } else {
      localStorage.setItem("vmixSettings", JSON.stringify(vmixSettings));
    }
  }, []);

  return (
    <Modal open={open} onClose={() => handleModalToggle(false)}>
      <Box sx={style} className="rounded-2xl overflow-y-auto max-h-screen min-h-[600px]">
        <Box className="flex items-center justify-between w-full bg-blue-500 px-4 py-3 rounded-t-xl">
          <p className="text-white font-medium text-xl">vMix Settings</p>
          <Box>
            <IconButton
              className="text-white"
              onClick={async () => {
                const url = "chrome://flags/#local-network-access-check";
                try {
                  await navigator.clipboard.writeText(url);
                  alert("The Chrome flags page URL has been copied.\n" + "Paste it into Chrome's address bar:\n\n" + url);
                } catch (e) {
                  alert("Copy failed. Please open Chrome and paste this manually:\n\n" + url);
                }
              }}
            >
              <FlagCircleIcon fontSize="large" />
            </IconButton>
            <IconButton
              className="text-white"
              onClick={() => {
                navigate("/keyboardEdit");
              }}
            >
              <KeyboardIcon fontSize="large" />
            </IconButton>
            <IconButton className="text-white" onClick={() => handleModalToggle(false)}>
              <i className="fa-solid fa-circle-xmark"></i>
            </IconButton>
          </Box>
        </Box>
        <Box className="flex w-full flex-col items-center justify-center px-10 py-4 gap-3">
          <Box className="flex justify-start items-center w-full gap-6">
            <Typography
              className="font-semibold w-1/3"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              V-Mix API URL
            </Typography>
            <Typography
              className="font-semibold"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              :
            </Typography>

            <TextField
              placeholder="http://127.0.0.1:8088"
              size="small"
              className="w-[250px]"
              value={vmixSettings.webControllerUrl}
              onChange={handleVmixSettingsApiChange}
              name="webControllerUrl"
            />
          </Box>
          <Box className="flex justify-start items-center w-full gap-6">
            <Typography
              className="font-semibold w-1/3"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              Overlay Number
            </Typography>
            <Typography
              className="font-semibold"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              :
            </Typography>
            <TextField
              placeholder="Channel ID"
              size="small"
              className="w-[250px]"
              value={vmixSettings.overlayChannelId}
              onChange={handleVmixSettingsChange}
              name="overlayChannelId"
              type="number"
            />
          </Box>
          <Box className="flex justify-start items-center w-full gap-6">
            <Typography
              className="font-semibold w-1/3"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              Input ID
            </Typography>
            <Typography
              className="font-semibold"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              :
            </Typography>
            <TextField
              placeholder="Input ID"
              size="small"
              className="w-[250px]"
              value={vmixSettings.inputId}
              onChange={handleVmixInputIDSettingsChange}
              name="inputId"
            />
          </Box>
          <Box className="flex justify-start items-center w-full gap-6">
            <Typography
              className="font-semibold w-1/3"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              Two Line Input ID
            </Typography>
            <Typography
              className="font-semibold"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              :
            </Typography>
            <TextField
              placeholder="Input ID"
              size="small"
              className="w-[250px]"
              value={vmixSettings.twoLineInputId}
              onChange={handleVmixInputIDSettingsChange}
              name="twoLineInputId"
            />
          </Box>
          {/* switch */}
          <Box className="flex justify-start items-center w-full gap-6">
            <Typography
              className="font-semibold w-1/3"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              vMix Text Input
            </Typography>
            <Typography
              className="font-semibold"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              :
            </Typography>
            {/* manual mode */}

            <Switch checked={manualMode} onChange={handleVmixSettingsManualMode} inputProps={{ "aria-label": "controlled" }} />
            {/* <SwitchComp
              name={"manualMode"}
              checked={manualMode}
              handleChange={handleVmixSettingsManualMode}
            /> */}
          </Box>
          <Box className="flex justify-start items-center w-full gap-6">
            <Typography
              className="font-semibold w-1/3"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              Text Input ID
            </Typography>
            <Typography
              className="font-semibold"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              :
            </Typography>
            <TextField
              disabled={!manualMode}
              placeholder="Enter your input"
              size="small"
              className="w-[250px]"
              value={vmixSettings.input}
              onChange={handleVmixSettingsInputTextIDChange}
              name="input"
              type="text"
            />
          </Box>
          <Box className="flex justify-start items-center w-full gap-6">
            <Typography
              className="font-semibold w-1/3"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              Line 1 ID
            </Typography>
            <Typography
              className="font-semibold"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              :
            </Typography>
            <TextField
              disabled={!manualMode}
              placeholder="Enter Selected Name 1"
              size="small"
              className="w-[250px]"
              value={vmixSettings.selectedName1}
              onChange={handleVmixSettingsInputTextIDChange}
              name="selectedName1"
              type="text"
            />
          </Box>
          <Box className="flex justify-start items-center w-full gap-6">
            <Typography
              className="font-semibold w-1/3"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              Line 2 ID
            </Typography>
            <Typography
              className="font-semibold"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              :
            </Typography>
            <TextField
              disabled={!manualMode}
              placeholder="Enter Selected Name 2"
              size="small"
              className="w-[250px]"
              value={vmixSettings.selectedName2}
              onChange={handleVmixSettingsInputTextIDChange}
              name="selectedName2"
              type="text"
            />
          </Box>
          <Box className="flex justify-start items-center w-full gap-6">
            <Typography
              className="font-semibold w-1/3"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              Source
            </Typography>
            <Typography
              className="font-semibold"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              :
            </Typography>

            {/* source mode */}

            <Switch checked={sourceMode} onChange={handleVmixSettingsSourceMode} inputProps={{ "aria-label": "controlled" }} />
          </Box>
          <Box className="flex justify-start items-center w-full gap-6">
            <Typography
              className="font-semibold w-1/3"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              Record
            </Typography>
            <Typography
              className="font-semibold"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              :
            </Typography>

            {/* record mode */}

            <Switch checked={recordMode} onChange={handleVmixSettingsRecordMode} inputProps={{ "aria-label": "controlled" }} />
          </Box>
          <Box className="flex justify-start items-center w-full gap-6">
            <Typography
              className="font-semibold w-1/3"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              Stream
            </Typography>
            <Typography
              className="font-semibold"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              :
            </Typography>

            {/* stream mode */}

            <Switch checked={streamMode} onChange={handleVmixSettingsStreamMode} inputProps={{ "aria-label": "controlled" }} />
          </Box>
          <Box className="flex justify-start items-center w-full gap-6">
            <Typography
              className="font-semibold w-1/3"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              V-Mix
            </Typography>
            <Typography
              className="font-semibold"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              :
            </Typography>

            {/* vMixApi mode */}

            <Switch checked={vMixApi} onChange={handleVmixSettingsVMixApiMode} inputProps={{ "aria-label": "controlled" }} />
          </Box>
          <Box className="flex justify-start items-center w-full gap-6">
            <Typography
              className="font-semibold w-1/3"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              MixerApi
            </Typography>
            <Typography
              className="font-semibold"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              :
            </Typography>

            {/* mixer mode */}

            <Switch checked={mixerApi} onChange={handleVmixSettingsMixerApiMode} inputProps={{ "aria-label": "controlled" }} />
          </Box>
          {mixerApi && (
            <Box className="flex justify-start items-center w-full gap-6">
              <Typography
                className="font-semibold w-1/3"
                sx={{
                  fontSize: "17px",
                  fontWeight: "600",
                }}
              >
                Mixer API URL
              </Typography>
              <Typography
                className="font-semibold"
                sx={{
                  fontSize: "17px",
                  fontWeight: "600",
                }}
              >
                :
              </Typography>

              <TextField
                placeholder="http://127.0.0.1:8000/api/location/5/1/1/press"
                size="small"
                className="w-[250px]"
                value={vmixSettings.mixerApiUrl}
                onChange={handleMixerSettingsApiChange}
                name="mixerApiUrl"
              />
            </Box>
          )}
          <Box className="flex justify-start items-center w-full gap-6">
            <Typography
              className="font-semibold w-1/3"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              Obs
            </Typography>
            <Typography
              className="font-semibold"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              :
            </Typography>

            {/* obs mode */}

            <Switch checked={obs} onChange={handleVmixSettingsObsMode} inputProps={{ "aria-label": "controlled" }} />
          </Box>

          <Box className="flex justify-start items-center w-full gap-6">
            <Typography
              className="font-semibold w-1/3"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              V-Cam
            </Typography>
            <Typography
              className="font-semibold"
              sx={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              :
            </Typography>

            {/* v-cam mode */}

            <Switch checked={vCam} onChange={handleVmixSettingsVCamMode} inputProps={{ "aria-label": "controlled" }} />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default SettingModal;
